import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export const OpportunityBasicInfoComponent = ({
    handleInnerFormChange, tagNames, accountNameList, campaigns, contactNameLists,
    opportunityType, leadSource, opportunityStage, selectedOpportunity
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Name"
                            name="Name"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.Name',
                                    selectedOpportunity?.OpportunityInformation
                                )
                            }}
                            type="text"
                            value={selectedOpportunity?.OpportunityInformation?.Name}
                        />
                        <InputContainer
                            label="IsPrivate"
                            name="IsPrivate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'OpportunityInformation.IsPrivate',
                                    selectedOpportunity?.OpportunityInformation
                                )
                            }}
                            type="checkbox"
                            value={selectedOpportunity?.OpportunityInformation?.IsPrivate}
                        />
                        <InputContainer
                            label="Account"
                            labelField="Name"
                            list={accountNameList}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.AccountId',
                                    selectedOpportunity?.OpportunityInformation
                                );
                            }}
                            optionName='Choose Account'
                            type="select"
                            value={selectedOpportunity?.OpportunityInformation?.AccountId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Contact Name"
                            labelField="FirstName"
                            list={contactNameLists}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.ContactId',
                                    selectedOpportunity?.OpportunityInformation
                                );
                            }}
                            optionName='Choose Contact'
                            type="select"
                            value={selectedOpportunity?.OpportunityInformation?.ContactId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Type"
                            labelField="Text"
                            list={opportunityType}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.Type',
                                    selectedOpportunity?.OpportunityInformation
                                );
                            }}
                            optionName='Choose Type'
                            type="select"
                            value={selectedOpportunity?.OpportunityInformation?.Type}
                            valueField="Value"
                        />

                        <InputContainer
                            label="Lead Source"
                            labelField="Text"
                            list={leadSource}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.LeadSource',
                                    selectedOpportunity?.OpportunityInformation
                                );
                            }}
                            optionName='Choose Lead Source'
                            type="select"
                            value={selectedOpportunity?.OpportunityInformation?.LeadSource}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Amount"
                            name="Amount"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.Amount',
                                    selectedOpportunity?.OpportunityInformation
                                )
                            }}
                            type="number"
                            value={selectedOpportunity?.OpportunityInformation?.Amount}
                        />
                        <InputContainer
                            label="CloseDate"
                            name="CloseDate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.CloseDate',
                                    selectedOpportunity?.OpportunityInformation
                                )
                            }}
                            type="date"
                            value={selectedOpportunity?.OpportunityInformation?.CloseDate}
                        />
                        <InputContainer
                            label="NextStep"
                            name="NextStep"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.NextStep',
                                    selectedOpportunity?.OpportunityInformation
                                )
                            }}
                            type="text"
                            value={selectedOpportunity?.OpportunityInformation?.NextStep}
                        />
                        <InputContainer
                            label="Probability"
                            name="Probability"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.Probability',
                                    selectedOpportunity?.OpportunityInformation
                                )
                            }}
                            type="number"
                            value={selectedOpportunity?.OpportunityInformation?.Probability}
                        />
                        <InputContainer
                            label="Stage"
                            labelField="Text"
                            list={opportunityStage}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.Stage',
                                    selectedOpportunity?.OpportunityInformation
                                );
                            }}
                            optionName='Choose Stage'
                            type="select"
                            value={selectedOpportunity?.OpportunityInformation?.Stage}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Campaign"
                            labelField="Text"
                            list={campaigns}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityInformation.Campaign',
                                    selectedOpportunity?.OpportunityInformation
                                );
                            }}
                            optionName='Choose Campaign'
                            type="select"
                            value={selectedOpportunity?.OpportunityInformation?.Campaign}
                            valueField="Value"
                        />
                    </div>
                }
                expandedPanel="Basic Info"
                headerTitle="Basic Info"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-1 lg:grid-cols-1 gap-1'>
                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OpportunityAdditionalInformation.Description',
                                    selectedOpportunity?.OpportunityAdditionalInformation
                                )
                            }}
                            type="text"
                            value={selectedOpportunity?.OpportunityAdditionalInformation?.Description}
                        />
                    </div>
                }
                expandedPanel="Additional Info"
                headerTitle="Opportunity Additional Information"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Tag"
                            labelField="displayText"
                            list={tagNames}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TagEntityMappingsValueIds',
                                );
                            }}
                            optionName='Choose Opportunity Tag'
                            type="select"
                            value={selectedOpportunity?.TagEntityMappingsValueIds}
                            valueField="ValueId"
                        />
                    </div>
                }
                expandedPanel="Opportunity Tag"
                headerTitle="Opportunity Tag"
            />
        </>
    )
}
export default OpportunityBasicInfoComponent;
